<template>
    <div :style="innerStyle" :class="'more pr cp oh cr-white ' + innerClass" :data-name="name" @click="on_click">
        <div class="line ani pa bg-primary ht-auto"></div>
        <div class="pa-c lh-40">
            查看更多
            <span class="pa arrow icon-youjiantou iconfont txt-size-12 arrow_act"></span>
        </div>
    </div>
</template>
<script>
const getVal = val => {
    const reg = /^[0-9]*$/g;
    return typeof val === 'number' || reg.test(val) ? val + 'px' : val;
};
export default {
    props: {
        name:'',
        innerClass: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 150,
        },
        height: {
            type: [Number, String],
            default: 48,
        },
        radius: {
            type: [Number, String],
            default: 0,
        },
        background: {
            type: String,
            default: 'rgba(255, 255, 255, 0.1)',
        },
    },
    data() {
        return {};
    },
    filters: {},
    computed: {
        innerStyle() {
            let style = '',
                { width, height, background, radius } = this;
            if (width) style += `width:${getVal(width)};`;
            if (height) style += `height:${getVal(height)};`;
            if (background) style += `background:${background};`;
            if (radius) style += `border-radius:${getVal(radius)};`;
            return style;
        },
    },
    watch: {},
    methods: {
        on_click(e){
            if(!e.currentTarget.dataset.name){
                this.$emit('on_click');
            }else{
                this.url_event_blank(e)
            };
        }
    },
    created() {},
    mounted() {},
};
</script>
<style lang="less" scoped>
.arrow {
    right: -14px;
    top: 50%;
}
.line {
    width: 2%;
}
.more {
    &:hover {
        .line {
            width: 100%;
        }
    }
}
</style>
